<template>
    <div>
        <busy-modal :show="loading" :overlay="true"></busy-modal>
        <b-row>
            <b-col md="12">
                <charges-table
                    ref="charges"
                    v-model.sync="values.charges"
                    :totals="values.chargesTotals"
                    :meta-reservation-id="values.reservationId"
                    :booking-method="values.bookingMethod"
                    class="reservation-invoice-grid"
                ></charges-table>
            </b-col>
        </b-row>
        <b-row v-if="values.discounts.length > 0">
            <b-col md="12">
                <div class="grid-caption">Discounts</div>
                <discounts-table
                    ref="discounts"
                    v-model.sync="values.discounts"
                    :meta-reservation-id="values.reservationId"
                    class="reservation-invoice-grid"
                ></discounts-table>
            </b-col>
        </b-row>
        <b-row v-if="values.issuedPolicies.length > 0">
            <b-col md="12">
                <div class="grid-caption">Issued Policies</div>
                <issued-policies-table
                    ref="issuedPolicies"
                    v-model.sync="values.issuedPolicies"
                    :meta-reservation-id="values.reservationId"
                    class="reservation-invoice-grid"
                ></issued-policies-table>
            </b-col>
        </b-row>
        <b-row v-if="values.otherDeposits.length > 0">
            <b-col md="12">
                <div class="grid-caption">Other Deposits</div>
                <other-deposits-table
                    ref="otherDeposits"
                    v-model.sync="values.otherDeposits"
                    :totals="values.otherDepositsTotals"
                    :meta-reservation-id="values.reservationId"
                    class="reservation-invoice-grid"
                ></other-deposits-table>
            </b-col>
        </b-row>
        <b-row v-if="(values.transactionHistory.length > 1) || (isCancelled && values.transactionHistory.length > 0)">
            <b-col md="12">
                <div class="grid-caption">Transaction History</div>
                <transaction-history-table
                    ref="charges"
                    v-model.sync="values.transactionHistory"
                    :meta-reservation-id="values.reservationId"
                    class="reservation-invoice-grid"
                ></transaction-history-table>
            </b-col>
        </b-row>
        <b-row v-for="item in values.techInfos" v-bind:key="item.id">
            <b-col md="12">
                <tech-info-form
                    :initial-values="{
                        tech_info: item,
                        meta_reservation: values.reservation,
                        reservation_id: item.id,
                        meta_reservation_id: values.reservationId,
                    }"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import ChargesTable from './tables/charges-table.vue';
    import DiscountsTable from './tables/discounts-table.vue';
    import IssuedPoliciesTable from './tables/issued-policies-table.vue';
    import OtherDepositsTable from './tables/other-deposits-table.vue';
    import TransactionHistoryTable from './tables/transaction-history-table.vue';
    import TechInfoForm from './reservation-invoice-tech-info-form.vue';

    export default {
        name: 'ReservationInvoiceForm',
        components: {
            BusyModal,
            ChargesTable,
            DiscountsTable,
            IssuedPoliciesTable,
            OtherDepositsTable,
            TransactionHistoryTable,
            TechInfoForm,
        },
        props: {
            initialValues: {
                type: Object,
                default: () => ({}),
            },
        },
        computed: {
            ...mapGetters('header', ['userToday']),
            ...mapGetters('header', ['userUnicodeDateFormat']),
            isCancelled() {
                return (
                    this.values.reservation.reservation_status.state === 'CANCELLED'
                );
            },
        },
        data() {
            return {
                loading: false,
                values: this.getInitialValues(),
            };
        },
        methods: {
            getInitialValues() {
                return {
                    reservation: this.initialValues.reservationInvoice,
                    reservationId: this.initialValues.reservationInvoice.id,
                    bookingMethod: this.initialValues.reservationInvoice.booking_method,
                    charges: this.initialValues.reservationInvoice.reservation_data.charges || [],
                    chargesTotals: this.initialValues.reservationInvoice.reservation_data.charges_totals || [],
                    discounts: this.initialValues.reservationInvoice.reservation_data.discounts || [],
                    issuedPolicies: this.initialValues.reservationInvoice.reservation_data.issued_policies || [],
                    otherDeposits: this.initialValues.reservationInvoice.reservation_data.other_deposits || [],
                    otherDepositsTotals:
                        this.initialValues.reservationInvoice.reservation_data.other_deposits_totals || [],
                    transactionHistory:
                        this.initialValues.reservationInvoice.reservation_data.transaction_history || [],
                    techInfos: this.initialValues.reservationInvoice.reservation_data.tech_infos || [],
                };
            },
        },
        watch: {
            initialValues() {
                this.values = this.getInitialValues();
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    .grid-caption {
        color: #3d3d3d;
        font-size: 18px;
        width: auto;
        padding: 3px;
        padding-left: 0;
        font-weight: bold;
    }


</style>
